import cn from 'classnames';
import { LoanStatus } from '../../types/loan/LoanStatus';

interface LoanStatusLabelProps {
    status: LoanStatus;
}

export function LoanStatusLabel({ status }: LoanStatusLabelProps) {
    return (
        <div className={cn('label-status', {
            'label-status-draft': status === LoanStatus.Draft,
            'label-status-bidding': status === LoanStatus.Active,
            'label-status-priced': status === LoanStatus.Priced,
            'label-status-canceled': status === LoanStatus.Cancelled,
        })}>
            {status.toUpperCase()}
        </div>
    );
}
